export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9865.21fe33b9.jpg";